export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  date: string;
  image: string;
  author: string;
}

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 'b1',
    slug: 'best-hair-salons-abu-dhabi-2025',
    title: '10 Best Hair Salons in Abu Dhabi 2025 (Ranked by Real Customers)',
    excerpt: 'Discover the top-rated hair salons in Abu Dhabi for 2025. From creative coloring to precision cuts, we rank the best based on customer satisfaction and quality.',
    date: 'May 1, 2026',
    category: 'Hair Care',
    author: 'Elena, Creative Director',
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?q=80&w=1200&auto=format&fit=crop',
    content: `
      <p>Finding the right hair salon in a city as vibrant as Abu Dhabi can be a challenge. With so many options, how do you choose the one that truly understands your hair's needs?</p>
      
      <h2>1. MIER Beauty Lounge</h2>
      <p>Located at the Aloft Hotel Ground Floor, MIER Beauty Lounge has quickly risen to the top of the ranks. Known for their "luxury at ease" approach, they specialize in balayage, keratin treatments, and precision styling.</p>
      
      <h2>2. The Science of Styling</h2>
      <p>In 2025, Abu Dhabi residents are looking for more than just a haircut; they're looking for hair health. Salons that prioritize scalp care and premium product lines like L'Oreal and Wella are seeing the highest retention rates.</p>
      
      <h3>What to look for in a top salon:</h3>
      <ul>
        <li>Professional consultations before every service.</li>
        <li>Transparent pricing (no hidden costs).</li>
        <li>Expertise in the local climate's effects on hair.</li>
      </ul>
      
      <p>Whether you're visiting for a quick blow-dry before an ADNEC event or a full color transformation, these top-ranked salons ensure you leave feeling refined and confident.</p>
    `
  },
  {
    id: 'b2',
    slug: 'gel-vs-acrylic-vs-builder-gel-guide',
    title: 'Gel vs Acrylic vs Builder Gel Nails: A Complete UAE Guide',
    excerpt: 'Everything you need to know about choosing the right nail system for the Abu Dhabi climate. Which one lasts longer and looks more natural?',
    date: 'April 28, 2026',
    category: 'Nails',
    author: 'Isabella, Nail Artist',
    image: 'https://images.unsplash.com/photo-1604654894610-df490c81726a?q=80&w=1200&auto=format&fit=crop',
    content: `
      <p>In the heat and humidity of Abu Dhabi, your manicure needs to do more than just look good—it needs to last. But with so many options like gel, acrylic, and the rising star, builder gel, how do you choose?</p>
      
      <h2>The Classic: Gel Polish</h2>
      <p>Perfect for those who want long-lasting color on their natural nails without added length. It's flexible and provides a high-gloss finish that resists chipping for up to 2-3 weeks.</p>
      
      <h2>The Strong: Acrylic Extensions</h2>
      <p>If you're looking for serious length and durability, acrylic remains a staple. It's hard-wearing and provides a solid canvas for intricate nail art.</p>
      
      <h2>The Modern Choice: Builder Gel (BIAB)</h2>
      <p>Builder gel is taking Abu Dhabi by storm. It's thicker than regular gel and can be used to add short extensions or provide a strong overlay to natural nails. It's less damaging than acrylic and feels incredibly natural.</p>
      
      <h3>Which is right for you?</h3>
      <p>At MIER Beauty Lounge, we recommend <strong>Builder Gel</strong> for most clients looking to grow their natural nails while maintaining a luxury, salon-finished look.</p>
    `
  },
  {
    id: 'b3',
    slug: 'mesotherapy-beginners-guide-abu-dhabi',
    title: 'What is Mesotherapy? A Beginner\'s Guide for Abu Dhabi Residents',
    excerpt: 'Considering mesotherapy but not sure where to start? We break down the process, benefits, and what to expect during your session in Abu Dhabi.',
    date: 'April 25, 2026',
    category: 'Skin Treatments',
    author: 'Aisha K.',
    image: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?q=80&w=1200&auto=format&fit=crop',
    content: `
      <p>Mesotherapy is one of the most requested skin treatments in Abu Dhabi right now, yet many people are still unsure of what it actually entails.</p>
      
      <h2>The Process</h2>
      <p>Mesotherapy involves micro-injections of vitamins, enzymes, antioxidants, and plant extracts to rejuvenate and tighten skin. In Abu Dhabi's dry climate, it's particularly effective for intense hydration.</p>
      
      <h2>Is it Painful?</h2>
      <p>Most clients at MIER Beauty Lounge describe it as a light "pinching" sensation. We use premium products and precise techniques to ensure maximum comfort and minimal downtime.</p>
      
      <h3>Key Benefits:</h3>
      <ul>
        <li>Improved skin glow and radiance.</li>
        <li>Deep hydration that topical creams can't reach.</li>
        <li>Support for skin elasticity and texture.</li>
      </ul>
      
      <p>If you're looking to refresh your skin before a big event at ADNEC or simply want to combat the effects of city life, mesotherapy is a powerful tool in your skincare arsenal.</p>
    `
  }
];
